/**
 * Révèle les carrousels produits (.fx-carousel) quand ils entrent dans l'écran.
 * Les styles vivent dans carousel-animations.css.
 */
(function () {
  var VISIBLE_CLASS = 'fx-in-view';
  var observer = null;

  function reveal(section) {
    section.classList.add(VISIBLE_CLASS);
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(
      function (entries, obs) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          reveal(entries[i].target);
          obs.unobserve(entries[i].target);
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    return observer;
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll('.fx-carousel:not(.' + VISIBLE_CLASS + ')');
    if (!sections.length) return;

    var supported = 'IntersectionObserver' in window;
    for (var i = 0; i < sections.length; i++) {
      if (supported) {
        getObserver().observe(sections[i]);
      } else {
        reveal(sections[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Éditeur de thème : les sections sont réinjectées sans rechargement.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
